import React, { useState, useEffect } from 'react';
import Totalizer from 'components/NewCart/Totalizer';
import PubSub from 'services/PubSub';
import StorageService from 'services/StorageService';
import { deliveryMethods, actionsType, consumer } from 'config/constants';
import QuickPurchaseService from 'services/QuickPurchase';
import CartControls from 'components/NewCart/CartControls';
import NewCardAcountItem from 'components/AccountCardsList/NewCardLists/NewItems';
import WalletServices from 'services/Wallet';
import { withRouter } from "react-router-dom";
import CartService from 'services/Cart';
import Day from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/es';
import SalesChannel from 'services/SalesChannel';
import { methodToSla, walletPaymentsName, checkoutID } from 'config';
import TagManagerService from 'services/TagManager';
import CartAction from 'actions/Cart';
import useVariant from 'hooks/useVariant';
import Loader from 'components/Loader';
import style from './style.scss'; //NOSONAR

let init = true;

const QuickPurchase = (props) => {

    const [deliveryMode, setDeliveryMode] = useState(() => setInitialMethod())
    const [address, setAddress] = useState(null);
    const [pickupPoint, setPickupPoint] = useState(null);
    const [orderForm, setOrderForm] = useState(null);
    const [cardFavorite, setCardFavorite] = useState(null);
    const [receiverData, setReceiverData] = useState(null);
    const [todayDeliveryWindow, setTodayDeliveryWindow] = useState(null);
    const [nextWindow, setNextWindow] = useState(null);
    const [currentDeliveryWindow, setDeliveryWindow] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [tooltipInfo, setTooltipInfo] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [shippingLoading, setShippingLoading] = useState(false);
    const [maxPrice, setMaxPrice] = useState(false);
    const storeLoading = props.loading;

    const userData = StorageService.getSecureItem('userData');

    const variant = useVariant(checkoutID);
    const newVariant = variant === '1';


    useEffect(() => {
        setOrderForm(props.orderForm);
        validateShipping(props.orderForm);
    }, [props.orderForm, props.loading]);
    
    useEffect(() => {
        let rut = null;
        if(orderForm){
            rut = orderForm?.clientProfileData?.document;
        }
        if((!(props.receiverData && props.receiverData.document) || (rut && props?.receiverData?.document && props.receiverData.document !== rut)) && orderForm){
            QuickPurchaseService.setReceiverData(orderForm);
        }

        setReceiverData(props.receiverData);
    }, [props.receiverData, orderForm]);

    useEffect(() => {
        if (init && orderForm){
            setLoading(true);
            setShippingLoading(true);
            const consults = [];
            consults.push(QuickPurchaseService.initialOrderForm(orderForm));
            consults.push(WalletServices.getWalletCards());
            consults.push(CartAction.getOrderInfo());
            
            Promise.all(consults).then((value) => {
                QuickPurchaseService.initPaymentData(orderForm).then((initPay) => {
                    const currentCard = initPay.card;
                    const cards = value[1].results ? value[1].results : [];
                    if(cards && currentCard){
                        let newCard = cards?.filter(element => element.isFavorite && element.token === currentCard.token)[0]
                        setCardFavorite(newCard);
                    }
                    setLoading(false);
                    TagManagerService.drawerQuickPurchase(1, 'Compra rápida', addressGtm, currentCard.brand , initPay.items);

                })
                setShippingLoading(false);
            })
            init = false;
        }
    }, [orderForm]);

    useEffect(() => {
        return function cleanup() {
            init = true
        }
    }, []);

    const validateShipping = (orderForm) => {
        const _deliveryMode = setInitialMethod();
        setDeliveryMode(_deliveryMode);
        if(orderForm?.shippingData?.address){
            if (_deliveryMode === deliveryMethods.homeDelivery) {
                setAddress(getAddress(orderForm))
            }
            if (_deliveryMode === deliveryMethods.carPickup || _deliveryMode === deliveryMethods.storePickup) {
                setPickupPoint(getPickupPoint(orderForm))
            }
            _setDeliveryWindows(orderForm);
            _setNextWindow(orderForm);
        }
    }
    
    const _sortDate = (daysDelivery) => {
        return daysDelivery.sort((a, b) => {
            a = new Date(a.endDateUtc).getTime();
            b = new Date(b.endDateUtc).getTime();
            return a < b ? -1 : a > b ? 1 : 0;
        });
    }

    const _setDeliveryWindows = (orderForm) => {
        const seller = SalesChannel.getSeller();
        const preselectesShipping = SalesChannel.getMethodName();
        let deliveryWindow = CartService.getDeliveryWindow(orderForm, preselectesShipping, seller);
        if(!deliveryWindow) return null;

        deliveryWindow.serverDateUtc = Day().format('YYYY-MM-DDTHH:mm:ss');
        StorageService.setItem('deliverySelected', JSON.stringify(deliveryWindow));

        setDeliveryWindow(deliveryWindow)
    }

    const _setNextWindow = (_orderForm) => {
        let seller = SalesChannel.getSeller();
        let sla =  CartService.getSlasOF(_orderForm, seller, methodToSla[deliveryMode]);

        if(!(sla && sla.length && sla[0].availableDeliveryWindows?.length)){
            setNextWindow(null);
            return false
        } 

        let _windows = _sortDate(sla[0].availableDeliveryWindows);
        let DatefirstWindow = Day(_windows[0].startDateUtc).format('YYYY-MM-DD');
        let nextWindow = null;
        for (let win of _windows){                                    
            if (!win.startDateUtc.includes(DatefirstWindow)){
                nextWindow = win;
                break;
            }  
        }

        setTodayDeliveryWindow({..._windows[0]});
        setNextWindow({...nextWindow});
    }
    
    const updateData = () => {
        PubSub.dispatch('update_client_open', {
            user: orderForm.clientProfileData,
        })
    }

    function setInitialMethod() {
        const methodFromStorage = StorageService.getItem('preselected_shipping_method')

        if (!methodFromStorage) {
            return deliveryMethods.homeDelivery
        }

        return methodFromStorage
    }

    const getPickupPoint = (orderForm) => {
        const storeName = StorageService.getItem('store_name')
        const friendlyName = orderForm.shippingData?.pickupPoints[0]?.friendlyName
        const address = getAddress(orderForm)

        if (friendlyName && friendlyName.includes(storeName)) {
            return {friendlyName, address}
        }
    }

    const getAddress = (orderForm) => {
        let orderFormAddress
        let addressId
        const localStorageAddressSelected = StorageService.getItem('addressSelected')

        if (deliveryMode === deliveryMethods.homeDelivery) {
            orderFormAddress = {...orderForm.shippingData?.address}
            addressId = orderFormAddress?.addressId

            if (StorageService.getItem('preselected_shipping_method') !== deliveryMethods.homeDelivery) {
                return null
            }

            if (addressId === localStorageAddressSelected) {
                return `${orderFormAddress.street} ${orderFormAddress.number}, ${orderFormAddress.neighborhood}, ${orderFormAddress.state}`
            } 

        } else if (deliveryMode === deliveryMethods.carPickup || deliveryMode === deliveryMethods.storePickup) {
            orderFormAddress = {...orderForm.shippingData?.pickupPoints[0]?.address}
            addressId = orderForm.shippingData?.pickupPoints[0]?.address?.addressId

            const _method = StorageService.getItem('preselected_shipping_method');
            if (_method !== deliveryMethods.carPickup && _method !== deliveryMethods.storePickup) {
                return null
            }

            return `${orderFormAddress.street} ${orderFormAddress.number}, ${orderFormAddress.neighborhood}, ${orderFormAddress.state}`
        }

        return false
    }

    const goToMiniCart = () => {
        PubSub.dispatch(actionsType.DRAWER.QUICK_PURCHASE_CLOSE);

        TagManagerService.interactionQuickPurchase('Clic', 'Botón volver', 'Compra rápida', userData.gtmSegment);

        PubSub.dispatch(actionsType.DRAWER.MINICART_OPEN)
    }

    const changeDate = (window) => {
        if(window.selected) return false;
        const _logistics = orderForm.shippingData.logisticsInfo;
        const _address = orderForm.shippingData.address;
        setShippingLoading(true);
        QuickPurchaseService.applyDeliveryWindow(_logistics, _address, window, deliveryMode).then(()=> {
            setShippingLoading(false);
        })
    }

    const formatDate = (date, i) => {
        let formatExpress = false;
        if(!currentDeliveryWindow) return '';

        if (formatExpress){
            let hourEnd = Day.extend(utc)(date.endDateUtc).utc().format('HH:mm');
            return <span key={i} className={"date-quick-purchase" + (date.selected ? ' selected' : '')}onClick={() => changeDate(date)} >`Hoy, antes de las ${hourEnd} hrs`;</span>
        }else{
            return <span key={i} className={"date-quick-purchase" + ((date.startDateUtc === currentDeliveryWindow.startDateUtc && (date.endDateUtc === currentDeliveryWindow.endDateUtc)) ? ' selected' : '')} onClick={() => changeDate(date)}>{CartService.formatDate(date)}</span>;
        }
    }

    const updateReceiverName = () => {
        setTimeout(()=> PubSub.dispatch('receiver_data_open',{
            address: orderForm.shippingData.address,
            clientProfileData: orderForm.clientProfileData,
            receiverData
        }),0);
    }

    const goToCheckout = (step, ev, validButton = false) => {
        if(ev) ev.preventDefault();

        PubSub.dispatch(actionsType.DRAWER.QUICK_PURCHASE_CLOSE)
        setTimeout(()=> {
            QuickPurchaseService.goToCheckout(step, props.history, newVariant);
        },200)

        if(step === 2) {
            if(validButton) {
                TagManagerService.interactionQuickPurchase('Clic', 'Ver más horario', 'Compra rápida', userData.gtmSegment);
            } else {
                TagManagerService.interactionQuickPurchase('Clic', 'Cambiar modo de entrega', 'Compra rápida', userData.gtmSegment);
            }
        } else if (step === 3) {
            TagManagerService.interactionQuickPurchase('Clic', 'Cambiar medio de pago', 'Compra rápida', userData.gtmSegment);
        }
    }

    const purchase = () => {
        if(storeLoading || isLoading || maxPrice || !orderForm || !addressMethod || !windows?.length) return '';

        setSubmitLoading(true);

        const callback = () => {
            setSubmitLoading(false);
        };

        TagManagerService.interactionQuickPurchase('Clic', 'Botón pagar', 'Compra rápida', userData.gtmSegment);

        const deliveries = StorageService.getItem('deliverySelected');
        const first = StorageService.getItem('firstWindowAvailable');
        const selectedDeliverieWindows = deliveries ? JSON.parse(deliveries) : '';
        const firstDeliveriesWindows = first ? JSON.parse(first) : '';
        const courierName = orderForm && orderForm.shippingData && orderForm.shippingData.logisticsInfo.length && orderForm.shippingData.logisticsInfo[0].slas && orderForm.shippingData.logisticsInfo[0].slas.length &&  orderForm.shippingData.logisticsInfo[0].slas[0] && orderForm.shippingData.logisticsInfo[0].slas[0].deliveryIds.length ? orderForm.shippingData.logisticsInfo[0].slas[0].deliveryIds[0].courierName: '' ;
        const deliveryType = StorageService.getItem('preselected_shipping_method');

        const ecommerceInfo = consumer.includes('santaisabel') ? StorageService.getItem('seller') : SalesChannel.getSalesChannel();

        TagManagerService.checkoutWindows( firstDeliveriesWindows, selectedDeliverieWindows, ecommerceInfo, methodToSla[deliveryType], courierName );

        StorageService.removeItem('deliverySelected');
        StorageService.removeItem('firstWindowAvailable');

        StorageService.setItem('is_quick_purchase', cardFavorite.brand);

        CartService.purchase(callback);

    }

    const hourTooltip = (open, event) => {
        event.preventDefault();
        setTooltipInfo(open)
    }

    const alertAmount = (maxAmount, block) => {
        const maxPriceAux = "$" + (Math.round(maxAmount)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        if(block) {
            setMaxPrice(true)
        } else {
            setTimeout(() => {
                PubSub.dispatch('open_snackbar',{
                    Subtitle: `Estás próximo a alcanzar el <strong>monto máximo de ${maxPriceAux} por día.</strong>`,
                    timer: 5000,
                    type: 'maxAmountInCart'
                });
            },0);
            setMaxPrice(false)
        }
    }

    const phone = orderForm?.clientProfileData?.phone;
    const receiverName = (receiverData && orderForm) ? (receiverData.document === orderForm?.clientProfileData?.document) ? 'Yo recibiré el pedido' :  receiverData?.firstName +' '+ receiverData?.lastName || '' : '';
    const windows = [todayDeliveryWindow, nextWindow].filter(Boolean);
    const _storeLoader = ((storeLoading && init) || !orderForm);
    const _componentLoader = (isLoading || storeLoading);
    const addressMethod = deliveryMode === "seller-1-sla-DespachoaDomicilio" ? address : pickupPoint ? pickupPoint.address : '';
    const titleAddress = deliveryMode === "seller-1-sla-DespachoaDomicilio" ? "Despacho" : "Retiro"
    const addressGtm = deliveryMode === "seller-1-sla-DespachoaDomicilio" ? "Despacho a domicilio" : "" || (deliveryMode === 'seller-1-sla-ClickalAuto' ? 'Retiro en Auto' : 'Retiro en tienda');
    const isDebit = (cardFavorite && cardFavorite.paymentMethod === walletPaymentsName.debitOneClick)

    return (
        <div className={'drawer-container quick-purchase-container'}>
            <h1 className="drawer-title">Finaliza tu compra</h1>
            <div className={'drawer-scroll'}>
                {_storeLoader && <span className="container-loaders">
                    <span className="loader-1"></span>
                    <span className="loader-2"></span>
                    <span className="loader-3"></span>
                    <span className="loader-4"></span>
                </span>}
                {!_storeLoader && <span className="quick-purchase-info">Tienes configurada tu dirección y medio de pago, te <strong>falta elegir el horario de entrega</strong> para comprar en un clic. Si falta algún producto, te llamaremos.</span>}
                {!_storeLoader && (_componentLoader || !addressMethod) && <span className="loader-6"></span>}

                {(!_storeLoader) && <div className="quick-purchase-data">
                    <div className="delivery-step-update-data">
                        <div className="delivery-step-update-data-text">
                            <span className="delivery-step-update-data-text-title">Datos de contacto</span>
                            <span className="delivery-step-update-data-text-phone">{phone}</span>
                        </div>
                        <button className="delivery-step-update-data-button" onClick={updateData}>Actualizar</button>
                    </div>
                </div>}

                {!_storeLoader && <div className='quick-purchase-delivery-mode'>
                    <div className="quick-purchase-delivery">
                        <div className="quick-purchase-title-container">
                            <h1 className='quick-purchase-delivery-mode-title'>Modo de entrega</h1>
                            <span className='quick-purchase-delivery-mode-info'>{titleAddress}</span>
                        </div>
                        <a className='quick-purchase-delivery-mode-change-link' onClick={(ev) => goToCheckout(2, ev)}>Cambiar</a>
                    </div>
                    <div className="quick-purchase-address-container">
                        <span className="quick-purchase-address-title" >{deliveryMode !== "seller-1-sla-DespachoaDomicilio" ? 'Local' : 'Dirección'}</span>
                        {pickupPoint && <span className="quick-purchase-address-info">{pickupPoint.friendlyName}</span>}
                        <span className="quick-purchase-address-info">{addressMethod}</span>

                    </div>
                    {deliveryMode !== "seller-1-sla-DespachoaDomicilio" && <div className="quick-purchase-address-container">
                        <span className="quick-purchase-address-title" >Quién recibe</span>
                        <span className="quick-purchase-address-info">
                            {receiverName}
                            <button className="delivery-step-update-data-button" onClick={updateReceiverName}>Cambiar</button>    
                        </span>

                    </div>}
                    <div className="quick-purchase-delivery-hour-container">
                        <div className="quick-purchase-hour-title-wrap">
                            <span className="quick-purchase-delivery-hour-title">Horario de entrega</span>

                            <div className={'quick-purchase-tooltip-container '}>
                                <i className="jumbo-icon-new-info" onClick={(event) => hourTooltip(true, event)}></i>

                                <span className={"quick-purchase-tooltip " + (tooltipInfo ? ' open ' : '')}>
                                    Los pedidos que se entregan a primera hora del día, los preparamos desde las 8:00 AM. Recuerda que el shopper te podría llamar para sustituir productos

                                    <i className="jumbo-icon-new-close" onClick={(event) => hourTooltip(false, event)}></i>
                                </span>
                            </div>
                        </div>
                        <div className="quick-purchase-delivery-hour-wrap">
                            <span className="content-windows-quick">{!!windows.length && windows.map((window, i) => formatDate(window, i))}</span>
                            {(!windows?.length && !_componentLoader && !!addressMethod) && <span className="express-alert">En este momento no tenemos horario de entrega disponibles, selecciona otro modo de entrega o intenta despues.</span>}
                            {!!windows?.length && <a className="quick-purchase-delivery-hour-link" onClick={(ev) => goToCheckout(2, ev, true)}>Ver más horarios</a>}
                        </div>
                    </div>
                </div>}
                {!_storeLoader && <div className="quick-purchase-payment-container">
                    <div className="quick-purchase-payment">
                        <h1 className="quick-purchase-payment-title">Medio de pago</h1>
                        <a className="quick-purchase-payment-link" onClick={() => goToCheckout(3)}>Cambiar</a>
                    </div>
                    <div className="quick-purchase-payment-card">
                        <div className="quick-purchase-payment-card-info">
                            <NewCardAcountItem card={cardFavorite} isDebit={isDebit} quickPurchase={true}/>
                        </div>
                    </div>

                </div>}
                
                {orderForm && !_storeLoader && <Totalizer orderForm={orderForm} customTitle="Total" alertAmount={alertAmount} isQuickPurchase={true}></Totalizer>}
            </div>

            <div className={'drawer-actions'}>
                {orderForm && <Totalizer orderForm={orderForm} customTitle="Total" alertAmount={alertAmount} >
                    <CartControls orderForm={orderForm} submitLoading={submitLoading}  disabledOptions={{products: false, submit: false,  maxPrice: maxPrice, disableGoBack: false}}/>
                </Totalizer>}

                <div className="quick-purchase-buttons-wrap">
                    <button className="secundary-btn" onClick={goToMiniCart}>Volver</button>
                    {!submitLoading && <button className={"primary-btn" + ((_storeLoader || _componentLoader || shippingLoading || maxPrice || !windows?.length) ? ' disabled-btn' : '')} onClick={purchase}>Pagar</button>}
                    {submitLoading && <button className="primary-btn content-loader-purchase"><Loader/></button>}
                </div>
            </div>
        </div>
    );
}

export default withRouter(QuickPurchase);
